import { render, staticRenderFns } from "./name-editor.vue?vue&type=template&id=9ad96f36&scoped=true&"
import script from "./name-editor.vue?vue&type=script&lang=js&"
export * from "./name-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad96f36",
  null
  
)

export default component.exports